// Shape diagram element (spec §7). The Connect-native target a Desktop `.pipe`
// geometric_shape annotation maps into (F2). A pure visualization object — it does
// not affect the solver. `position` (top-left) + `size` are in Connect canvas
// coordinates (Y-down), transformed on import with the same positionScale + Y-mirror
// as vertices/edges — including width/height (F2, finding §2.9).

import { z } from 'zod';
import { PointSchema, RgbaSchema } from '../base/common';

export const ShapeKindSchema = z.enum(['rectangle', 'ellipse', 'line', 'polygon']);
export type ShapeKind = z.infer<typeof ShapeKindSchema>;

export const ShapeElementSchema = z.object({
  id: z.string(),
  kind: z.literal('shape'),
  /** Which primitive; a bare Desktop geometric_shape maps to 'rectangle'. */
  shape: ShapeKindSchema.default('rectangle'),
  position: PointSchema,
  size: z.object({
    width: z.number().nonnegative(),
    height: z.number().nonnegative(),
  }),
  /** Stroke/outline color. */
  color: RgbaSchema.optional(),
  /** Fill color; absent → unfilled. */
  fill: RgbaSchema.optional(),
  /** Editing lock carried over from Desktop. */
  locked: z.boolean().default(false),
});

export type ShapeElement = z.infer<typeof ShapeElementSchema>;
